import React from 'react';

const Summary = ({ solved, codeTutor, codeTrack, codeTest, dt, dc, totalPoints, percentage, solvedPercentage, trackingMode }) => {
  const isPointsMode = !trackingMode || trackingMode === 'points' || !solved || solved === 0;
  
  return (
    <aside style={{ 
      textAlign: 'center', 
      margin: '20px auto', 
      padding: '20px', 
      border: `1px solid var(--summary-border)`,
      borderRadius: '8px', 
      backgroundColor: 'var(--card-bg)', 
      color: 'var(--text-color)',
      width: 'fit-content'
    }}>
      <h3 className='fix-width' >Points Calculation Summary</h3>
      <p>Code Tutor: {codeTutor} x 0 = 0</p>
      <p>Code Tracks: {codeTrack} x 2 = {codeTrack * 2}</p>
      <p>DC: {dc} x 2 = {dc * 2}</p>
      <p>DT: {dt} x 20 = {dt * 20}</p>
      <p>Code Tests: {codeTest} x 30 = {codeTest * 30}</p>
      <p style={{ 
        fontWeight: !isPointsMode ? 'bold' : 'normal',
        backgroundColor: !isPointsMode ? 'var(--progress-circle)' : 'transparent',
        color: !isPointsMode ? 'white' : 'inherit',
        margin: '0 0 12px 0',
        padding: '6px 12px',
        borderRadius: '6px',
        display: 'inline-block',
        transition: 'all 0.3s ease'
      }}>
        <strong>Solved = {solved}</strong> {solvedPercentage < 100 ? `(${solvedPercentage}%)` : ''}
      </p>
      <hr />
      <p style={{ 
        fontWeight: isPointsMode ? 'bold' : 'normal',
        backgroundColor: isPointsMode ? 'var(--progress-circle)' : 'transparent',
        color: isPointsMode ? 'white' : 'inherit',
        margin: '12px 0 0 0',
        padding: '6px 12px',
        borderRadius: '6px',
        display: 'inline-block',
        transition: 'all 0.3s ease'
      }}>
        <strong>Points = {totalPoints}</strong> {percentage < 100 ? `(${percentage}%)` : ''}
      </p>
    </aside>
  );
};

export default Summary;
